module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkInQuery"
  }, [_c('div', {
    staticClass: "fixed-content"
  }, [_c('div', {
    staticClass: "tabBtn"
  }, [_c('mt-navbar', {
    staticClass: "navBar",
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "1"
    }
  }, [_vm._v("宿舍报修")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "2"
    }
  }, [_vm._v("其他报修")]), _vm._v(" "), _c('mt-tab-item', {
    staticClass: "tabBtnNav1",
    attrs: {
      "id": "3"
    }
  }, [_vm._v("我的报修")])], 1)], 1)]), _vm._v(" "), (_vm.selected == 1) ? _c('div', {
    staticClass: "scroll-content scroll-content1"
  }, [_c('div', {
    staticClass: "tabContent margin-lr-30"
  }, [_c('div', {
    staticClass: "mesList padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "title titleMes color-333 font-size-14px margin-top-10"
  }, [_c('div', {
    staticClass: "leftMes"
  }, [_c('span', [_vm._v("报修人：")]), _vm._v(" "), _c('span', {
    staticClass: "color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.personName) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "rightMes"
  }, [_c('span', {
    staticClass: "color-333"
  }, [_vm._v("上网账号：")]), _vm._v(" "), _c('span', {
    staticClass: "margin-left-20 color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.personNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "title titleMes color-333 font-size-14px margin-top-10"
  }, [_c('div', {
    staticClass: "leftMes"
  }, [_c('span', [_vm._v("宿舍楼栋：")]), _vm._v(" "), _c('span', {
    staticClass: "color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.address) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "rightMes"
  }, [_c('span', {
    staticClass: "color-333"
  }, [_vm._v("-房间号:")]), _vm._v(" "), _c('span', {
    staticClass: "margin-left-20 color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.roomNo))])])])]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("*请选择床位")]), _vm._v(" "), _c('div', {
    staticClass: "rooms"
  }, [_c('div', {
    staticClass: "textDes"
  }, [_vm._v("宿舍入口")]), _vm._v(" "), _c('div', {
    staticClass: "allBed"
  }, [_c('div', {
    staticClass: "bed",
    class: {
      'bg-appStyle color-fff': _vm.bedNum == 1
    },
    on: {
      "click": function($event) {
        return _vm.chooseBed(1)
      }
    }
  }, [_vm._v("1号床")]), _vm._v(" "), _c('div', {
    staticClass: "bed",
    class: {
      'bg-appStyle color-fff': _vm.bedNum == 2
    },
    on: {
      "click": function($event) {
        return _vm.chooseBed(2)
      }
    }
  }, [_vm._v("2号床")]), _vm._v(" "), _c('div', {
    staticClass: "bed",
    class: {
      'bg-appStyle color-fff': _vm.bedNum == 3
    },
    on: {
      "click": function($event) {
        return _vm.chooseBed(3)
      }
    }
  }, [_vm._v("3号床")]), _vm._v(" "), _c('div', {
    staticClass: "bed",
    class: {
      'bg-appStyle color-fff': _vm.bedNum == 4
    },
    on: {
      "click": function($event) {
        return _vm.chooseBed(4)
      }
    }
  }, [_vm._v("4号床")])]), _vm._v(" "), _c('div', {
    staticClass: "textDes"
  }, [_vm._v("厕所阳台")])]), _vm._v(" "), _c('div', {
    staticClass: "item-input margin-top-20"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("*联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bxTel),
      expression: "bxTel"
    }],
    staticClass: "input-text font-size-28",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请填写联系电话"
    },
    domProps: {
      "value": (_vm.bxTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bxTel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10 color-tipRed font-size-26"
  }, [_vm._v("注意：若是融合套餐用户请输入电信融合套餐手机号。")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("*请选择故障")]), _vm._v(" "), _c('div', {
    staticClass: "gzBoxs"
  }, [_c('div', {
    staticClass: "box bg-no",
    class: {
      'bg-fff color-appStyle': _vm.wired == 'wired'
    },
    on: {
      "click": function($event) {
        return _vm.chooseWired('wired')
      }
    }
  }, [_vm._v("有线")]), _vm._v(" "), _c('div', {
    staticClass: "box bg-no",
    class: {
      'bg-fff color-appStyle': _vm.wired == 'wireless'
    },
    on: {
      "click": function($event) {
        return _vm.chooseWired('wireless')
      }
    }
  }, [_vm._v("无线")])]), _vm._v(" "), _c('div', {
    staticClass: "gzBoxs"
  }, _vm._l((_vm.gzList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'bg-appStyle color-fff': item.isChoose
      },
      on: {
        "click": function($event) {
          return _vm.chooseGz(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("问题描述")]), _vm._v(" "), _c('div', {
    staticClass: "bg-fff"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wentiDes),
      expression: "wentiDes"
    }],
    staticClass: "HqTextarea font-size-28 full-width margin-top-10",
    attrs: {
      "elastic": "",
      "placeholder": "请您对故障情况做简单描述(选填)",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.wentiDes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wentiDes = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.selected == 2) ? _c('div', {
    staticClass: "scroll-content scroll-content1"
  }, [_c('div', {
    staticClass: "tabContent margin-lr-30"
  }, [_c('div', {
    staticClass: "mesList padding-20 bg-fff"
  }, [_c('div', {
    staticClass: "title color-333 font-size-14px margin-top-10"
  }, [_c('span', [_vm._v("报修人：")]), _vm._v(" "), _c('span', {
    staticClass: "color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.personName) + " ")]), _vm._v(" "), _c('span', {
    staticClass: "color-333"
  }, [_vm._v("上网账号：")]), _vm._v(" "), _c('span', {
    staticClass: "margin-left-20 color-666"
  }, [_vm._v(_vm._s(_vm.initMaintainIndex.personNo))])])]), _vm._v(" "), _c('div', {
    staticClass: "item-input"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("*报修位置")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bxLocation),
      expression: "bxLocation"
    }],
    staticClass: "input-text font-size-28",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "text",
      "placeholder": "请填写报修位置"
    },
    domProps: {
      "value": (_vm.bxLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bxLocation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "item-input margin-top-20"
  }, [_c('p', {
    staticClass: "label"
  }, [_vm._v("*联系电话")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bxTel),
      expression: "bxTel"
    }],
    staticClass: "input-text font-size-28",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "number",
      "placeholder": "请填写联系电话"
    },
    domProps: {
      "value": (_vm.bxTel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bxTel = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-10 color-tipRed font-size-28"
  }, [_vm._v("注意：若是融合套餐用户请输入电信融合套餐手机号。")]), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("*请选择故障")]), _vm._v(" "), _c('div', {
    staticClass: "gzBoxs"
  }, [_c('div', {
    staticClass: "box bg-no",
    class: {
      'bg-fff color-appStyle': _vm.wired == 'wired'
    },
    on: {
      "click": function($event) {
        return _vm.chooseWired('wired')
      }
    }
  }, [_vm._v("有线")]), _vm._v(" "), _c('div', {
    staticClass: "box bg-no",
    class: {
      'bg-fff color-appStyle': _vm.wired == 'wireless'
    },
    on: {
      "click": function($event) {
        return _vm.chooseWired('wireless')
      }
    }
  }, [_vm._v("无线")])]), _vm._v(" "), _c('div', {
    staticClass: "gzBoxs"
  }, _vm._l((_vm.gzList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "box",
      class: {
        'bg-appStyle color-fff': item.isChoose
      },
      on: {
        "click": function($event) {
          return _vm.chooseGz(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "subTitle margin-top-20"
  }, [_vm._v("问题描述")]), _vm._v(" "), _c('div', {
    staticClass: "bg-fff"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wentiDes),
      expression: "wentiDes"
    }],
    staticClass: "HqTextarea font-size-28 full-width margin-top-10",
    attrs: {
      "elastic": "",
      "placeholder": "请您对故障情况做简单描述(选填)",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.wentiDes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.wentiDes = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.selected == 3) ? _c('div', {
    staticClass: "scroll-content scroll-content1"
  }, [_c('mt-loadmore', {
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop,
      "bottom-method": _vm.loadBottom,
      "bottom-all-loaded": _vm.allLoaded,
      "auto-fill": false
    }
  }, [(_vm.list.length == 0) ? _c('div', {
    staticClass: "noData"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "7rem"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/images/default-null.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("暂时无相关数据")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "padding-20 bg-fff margin-top-20",
      on: {
        "click": function($event) {
          return _vm.openPage('RepairApplyDetial', item)
        }
      }
    }, [_c('div', {
      staticClass: "listBox"
    }, [_c('div', {
      staticClass: "mesList"
    }, [_c('div', {
      staticClass: "title color-333 font-size-14px"
    }, [_vm._v("报修时间：" + _vm._s(item.reportTime))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修类型：" + _vm._s(item.reportType))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("姓名：" + _vm._s(item.reporterName))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("上网账号：" + _vm._s(item.reporterNumber))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修位置：" + _vm._s(item.location))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("报修原因：" + _vm._s(item.reportCause))]), _vm._v(" "), _c('p', {
      staticClass: "color-666 font-size-26 margin-top-8"
    }, [_vm._v("联系电话：" + _vm._s(item.reporterPhone))])]), _vm._v(" "), _c('p', {
      staticClass: "typeStateBtn color-fff",
      class: {
        'bg-f9b625': item.orderStatusName == '待分配'
      }
    }, [_vm._v(_vm._s(item.orderStatusName))])]), _vm._v(" "), (item.reportOrderButtons.length > 0) ? _c('div', {
      staticClass: "border-top handleBoxs"
    }, _vm._l((item.reportOrderButtons), function(btnItem, key) {
      return _c('div', {
        key: key,
        staticClass: "handleBtn color-fff",
        on: {
          "click": function($event) {
            return _vm.closeItem($event, btnItem, item)
          }
        }
      }, [_vm._v(_vm._s(btnItem))])
    }), 0) : _vm._e()])
  })], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.selected != 3) ? _c('div', {
    staticClass: "footerBtn"
  }, [_c('div', {
    staticClass: "btn bg-appStyle",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn bg-appStyle",
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("提交")])]) : _vm._e(), _vm._v(" "), (_vm.showMesBox) ? _c('v-messagebox', {
    attrs: {
      "mes-box-title": _vm.mesBoxTitle,
      "mes-box-type": _vm.mesBoxType
    },
    on: {
      "change": _vm.mesBosChange
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fa0dcac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/RepairApply.vue
// module id = 866
// module chunks = 1